module.exports = __webpack_public_path__ + "8ec445f92ce71e8adef5d167acb62866.png";